"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

import { GTM_EVENT, GTM_EVENT_NAME } from "@/internals/constants/events";
import { isStripeCriticalPath } from "@/internals/constants/paths";
import { scheduleIdle } from "@/utils/browser";

export const HistoryEvent = () => {
  const pathname = usePathname();
  useEffect(() => {
    const pushPageView = () => {
      window?.dataLayer?.push({
        event: GTM_EVENT_NAME.PAGE_VIEW,
        page: pathname,
      } as GTM_EVENT);
    };

    // Only defer the dataLayer push on Stripe-critical routes so Stripe ECE
    // isn't starved by GTM work
    if (!isStripeCriticalPath(pathname)) {
      pushPageView();
      return;
    }
    const cancel = scheduleIdle(pushPageView, 2000);
    return cancel;
  }, [pathname]);
  return null;
};
